import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HealthSubNav from './HealthSubNav';
import HealthDisclaimer from './HealthDisclaimer';

import HealthLanding from '../../pages/health/HealthLanding';
import HealthPrinciples from '../../pages/health/HealthPrinciples';
import HealthSugar from '../../pages/health/HealthSugar';
import HealthByAge from '../../pages/health/HealthByAge';
import HealthAgeBracket from '../../pages/health/HealthAgeBracket';
import HealthFood from '../../pages/health/HealthFood';
import HealthFoodTopic from '../../pages/health/HealthFoodTopic';

const HealthLayout = () => {
  return (
    <div className="health-layout">
      <HealthSubNav />
      <div className="health-main">
        <Routes>
          <Route index element={<HealthLanding />} />
          <Route path="principles" element={<HealthPrinciples />} />
          <Route path="sugar" element={<HealthSugar />} />
          <Route path="by-age" element={<HealthByAge />} />
          <Route path="by-age/:slug" element={<HealthAgeBracket />} />
          <Route path="food" element={<HealthFood />} />
          <Route path="food/:slug" element={<HealthFoodTopic />} />
        </Routes>
      </div>
      <HealthDisclaimer />
    </div>
  );
};

export default HealthLayout;
